export interface ZoneObject {
  objectType: ZoneObjectType.DOOR | ZoneObjectType.BOX;
  objectId: string;
}

export enum ZoneObjectType {
  DOOR = 'door',
  BOX = 'box',
}
